var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElIconInstagram = function SvgElIconInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#el-icon-instagram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.75 1.75h11.083v10.5H1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4405F",
    d: "M9.107 3.343h-.193a49.025 49.025 0 0 0-3.779 0c-.92-.097-1.695.581-1.792 1.502v4.069c-.097.92.581 1.695 1.501 1.792h.291c1.26.049 2.52.049 3.779 0 1.114 0 1.744-.678 1.792-1.792.049-1.26.049-2.52 0-3.779.049-.92-.678-1.744-1.599-1.792ZM7.024 9.398A2.443 2.443 0 0 1 4.65 7.024 2.378 2.378 0 0 1 7.024 4.65a2.443 2.443 0 0 1 2.374 2.374 2.378 2.378 0 0 1-2.374 2.374Zm2.423-4.263a.56.56 0 0 1-.582-.581c0-.29.242-.582.533-.582h.049c.29 0 .581.29.581.582a.56.56 0 0 1-.581.581Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4405F",
    d: "M10.851 0H3.15A3.142 3.142 0 0 0 0 3.149v7.702A3.142 3.142 0 0 0 3.149 14h7.702A3.142 3.142 0 0 0 14 10.851V3.15A3.142 3.142 0 0 0 10.851 0Zm.678 9.107c-.048.533-.29 1.066-.581 1.502a2.668 2.668 0 0 1-2.18.92H5.134c-.63.05-1.308-.193-1.792-.58a2.668 2.668 0 0 1-.92-2.18V5.376c0-.242 0-.484.048-.726.097-1.018.823-1.841 1.841-2.083l.533-.146h4.36c.096.049.242.049.339.097.872.145 1.598.775 1.84 1.599.05.242.097.484.146.726v4.263Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4405F",
    d: "M7.024 5.522c-.823 0-1.502.63-1.502 1.454s.63 1.502 1.453 1.502c.824 0 1.502-.63 1.502-1.454v-.048c0-.775-.63-1.454-1.453-1.454Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "el-icon-instagram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgElIconInstagram;